export class GetKpiList{
  static readonly type = '[KPI-Configuration] Get kpi list'
}
  
export class ClearKpiConfigurationState{
  static readonly type = '[KPI-Configuration] Clear KPI Configuration state'
}

export class SetSelectedKPIs {
  static readonly type = '[KPI-Configuration] Set Selected Kpi List'
  constructor(public selectedKPIs: any[]){}
}

export class RemoveSelectedKPI {
  static readonly type = '[KPI-Configuration] Removed Selected Kpi '
  constructor(public selectedKPI: any){}
}

export class UpdateKPIActionIn {
  static readonly type = '[KPI-Configuration] Update KPI Action in'
  constructor(public selectedKPI: any){}
}

export class SubmitKPIConfiguration {
  static readonly type = '[KPI-Configuration] Submit KPI Configuration'
  constructor(public category: any, public selectedKpis: any){}
}

export class ResetCreateConfigStatus {
  static readonly type ='[KPI-Configuration] Reset create config status'
}

export class SetConfiguredKpiList {
  static readonly type ='[KPI-Configuration] Set configured KPI list'
  constructor(public configuredKPIs: any[]) {}
}

export class SetKPIMode {
  static readonly type ='[KPI-Configuration] Set KPI mode'
  constructor(public mode: number) {}
}

export class GetEditKPIConfiguration {
  static readonly type ='[KPI-Configuration] Set Configuration to edit'
  constructor(public configId: string) {}
}

export class SaveEditKPIConfiguration {
  static readonly type = '[KPI-Configuration] Save Edit KPI Configuration'
  constructor(public configId: string, public category: any, public editKPI: any){}
}
